/* global APP */
// @ts-ignore
import Logger from '@vietmeet/logger';
import { createApiEvent } from '../../react/features/analytics/AnalyticsEvents';
import { sendAnalytics } from '../../react/features/analytics/functions';
import { approveParticipantAudio, approveParticipantVideo, rejectParticipantAudio, rejectParticipantVideo, requestDisableAudioModeration, requestDisableVideoModeration, requestEnableAudioModeration, requestEnableVideoModeration } from '../../react/features/av-moderation/actions';
import { isEnabledFromState, isForceMuted } from '../../react/features/av-moderation/functions';
import { endConference, sendTones, setAssumedBandwidthBps, setLocalSubject, setPassword, setSubject } from '../../react/features/base/conference/actions';
import { getCurrentConference, isP2pActive } from '../../react/features/base/conference/functions';
import { overwriteConfig } from '../../react/features/base/config/actions';
import { getWhitelistedJSON } from '../../react/features/base/config/functions.any';
import { toggleDialog } from '../../react/features/base/dialog/actions';
import { isSupportedBrowser } from '../../react/features/base/environment/environment';
import { isMobileBrowser } from '../../react/features/base/environment/utils';
import { parseJWTFromURLParams } from '../../react/features/base/jwt/functions';
import { setLowBandwidthMode } from '../../react/features/base/low-bandwidth-mode/actions';
import { MEDIA_TYPE, VIDEO_TYPE } from '../../react/features/base/media/constants';
import { isVideoMutedByUser } from '../../react/features/base/media/functions';
import { grantModerator, kickParticipant, overwriteParticipantsNames, pinParticipant, raiseHand } from '../../react/features/base/participants/actions';
import { LOCAL_PARTICIPANT_DEFAULT_ID } from '../../react/features/base/participants/constants';
import { getLocalParticipant, getNormalizedDisplayName, getParticipantById, getScreenshareParticipantIds, getVirtualScreenshareParticipantByOwnerId, hasRaisedHand, isLocalParticipantModerator, isParticipantModerator } from '../../react/features/base/participants/functions';
import { updateSettings } from '../../react/features/base/settings/actions';
import { getDisplayName } from '../../react/features/base/settings/functions.web';
import { setCameraFacingMode } from '../../react/features/base/tracks/actions.web';
import { CAMERA_FACING_MODE_MESSAGE } from '../../react/features/base/tracks/constants';
import { getLocalVideoTrack, isLocalTrackMuted } from '../../react/features/base/tracks/functions';
import VietMeetJS, { VietMeetRecordingConstants } from '../../react/features/base/vietmeet-lib';
import { autoAssignToBreakoutRooms, closeBreakoutRoom, createBreakoutRoom, moveToRoom, removeBreakoutRoom, sendParticipantToRoom } from '../../react/features/breakout-rooms/actions';
import { getBreakoutRooms, getRoomsInfo } from '../../react/features/breakout-rooms/functions';
import { sendMessage, setPrivateMessageRecipient, toggleChat } from '../../react/features/chat/actions';
import { openChat } from '../../react/features/chat/actions.web';
import { showDesktopPicker } from '../../react/features/desktop-picker/actions';
import { processExternalDeviceRequest } from '../../react/features/device-selection/functions';
import { appendSuffix } from '../../react/features/display-name/functions';
import { isEnabled as isDropboxEnabled } from '../../react/features/dropbox/functions';
import { setMediaEncryptionKey, toggleE2EE } from '../../react/features/e2ee/actions';
import { getE2EEBlockingService } from '../../react/features/e2ee/functions';
import { addStageParticipant, resizeFilmStrip, setFilmstripVisible, setVolume, togglePinStageParticipant } from '../../react/features/filmstrip/actions.web';
import { getPinnedActiveParticipants, isStageFilmstripAvailable } from '../../react/features/filmstrip/functions.web';
import { setFollowMe, setFollowMeRecorder } from '../../react/features/follow-me/actions';
import { invite } from '../../react/features/invite/actions.any';
import { selectParticipantInLargeVideo } from '../../react/features/large-video/actions.any';
import { captureLargeVideoScreenshot, resizeLargeVideo } from '../../react/features/large-video/actions.web';
import { answerKnockingParticipant, toggleLobbyMode } from '../../react/features/lobby/actions';
import { getLobbyEnabled } from '../../react/features/lobby/functions';
import { setSecondScreen } from '../../react/features/multi-screen/actions.web';
import { setNoiseSuppressionEnabled } from '../../react/features/noise-suppression/actions';
import { hideNotification, showNotification } from '../../react/features/notifications/actions';
import { NOTIFICATION_TIMEOUT_TYPE, NOTIFICATION_TYPE } from '../../react/features/notifications/constants';
import { close as closeParticipantsPane, open as openParticipantsPane } from '../../react/features/participants-pane/actions';
import { getParticipantsPaneOpen } from '../../react/features/participants-pane/functions';
import { handleHostDocumentPiPOpenFailed, handleHostDocumentPiPOpened, handleHostDocumentPiPSignal, handleHostDocumentPiPWindowClosed, hidePiP, showPiP } from '../../react/features/pip/actions';
import { setStartRecordingIntent, setStopRecordingIntent, startLocalVideoRecording, stopLocalVideoRecording } from '../../react/features/recording/actions.any';
import { grantRecordingConsent, grantRecordingConsentAndUnmute } from '../../react/features/recording/actions.web';
import { RECORDING_METADATA_ID, RECORDING_TYPES } from '../../react/features/recording/constants';
import { getActiveSession, supportsLocalRecording } from '../../react/features/recording/functions';
import { startAudioScreenShareFlow, startScreenShareFlow } from '../../react/features/screen-share/actions';
import { isScreenAudioSupported } from '../../react/features/screen-share/functions';
import { openCameraCaptureDialog, toggleScreenshotCaptureSummary } from '../../react/features/screenshot-capture/actions';
import { isScreenshotCaptureEnabled } from '../../react/features/screenshot-capture/functions';
import SettingsDialog from '../../react/features/settings/components/web/SettingsDialog';
import { SETTINGS_TABS } from '../../react/features/settings/constants';
import { playSharedVideo, stopSharedVideo } from '../../react/features/shared-video/actions';
import { extractYoutubeIdOrURL } from '../../react/features/shared-video/functions';
import { setRequestingSubtitles, toggleRequestingSubtitles } from '../../react/features/subtitles/actions';
import { setMeetingTimer } from '../../react/features/time-timer/actions';
import { isAudioMuteButtonDisabled } from '../../react/features/toolbox/functions';
import { setTileView, toggleTileView } from '../../react/features/video-layout/actions.any';
import { muteAllParticipants, muteRemote } from '../../react/features/video-menu/actions';
import { setVideoQuality } from '../../react/features/video-quality/actions';
import { toggleBackgroundEffect, toggleBlurredBackgroundEffect } from '../../react/features/virtual-background/actions';
import { VIRTUAL_BACKGROUND_TYPE } from '../../react/features/virtual-background/constants';
import { allowVoiceAgent, declineVoiceAgent } from '../../react/features/voice-agents/actions';
import { toggleWhiteboard } from '../../react/features/whiteboard/actions.web';
import { getVietMeetTransport } from '../transport';
import { API_ID, ENDPOINT_TEXT_MESSAGE_NAME } from './constants';
const logger = Logger.getLogger('api:core');
/**
 * List of the available commands.
 */
let commands = {};
/**
 * The transport instance used for communication with external apps.
 *
 * @type {Transport}
 */
const transport = getVietMeetTransport();
/**
 * The current audio availability.
 *
 * @type {boolean}
 */
let audioAvailable = true;
/**
 * The current video availability.
 *
 * @type {boolean}
 */
let videoAvailable = true;
/**
 * Initializes supported commands.
 *
 * @returns {void}
 */
function initCommands() {
    commands = {
        // @ts-ignore
        'add-breakout-room': name => {
            if (!isLocalParticipantModerator(APP.store.getState())) {
                logger.error('Missing moderator rights to add breakout rooms');
                return;
            }
            APP.store.dispatch(createBreakoutRoom(name));
        },
        // @ts-ignore
        'answer-knocking-participant': (id, approved) => {
            APP.store.dispatch(answerKnockingParticipant(id, approved));
        },
        // @ts-ignore
        'approve-video': participantId => {
            if (!isLocalParticipantModerator(APP.store.getState())) {
                return;
            }
            APP.store.dispatch(approveParticipantVideo(participantId));
        },
        // @ts-ignore
        'ask-to-unmute': participantId => {
            if (!isLocalParticipantModerator(APP.store.getState())) {
                return;
            }
            APP.store.dispatch(approveParticipantAudio(participantId));
        },
        'auto-assign-to-breakout-rooms': () => {
            if (!isLocalParticipantModerator(APP.store.getState())) {
                logger.error('Missing moderator rights to auto-assign participants to breakout rooms');
                return;
            }
            APP.store.dispatch(autoAssignToBreakoutRooms());
        },
        // @ts-ignore
        'grant-moderator': participantId => {
            if (!isLocalParticipantModerator(APP.store.getState())) {
                logger.error('Missing moderator rights to grant moderator right to another participant');
                return;
            }
            APP.store.dispatch(grantModerator(participantId));
        },
        // @ts-ignore
        'grant-recording-consent': unmute => {
            unmute ? APP.store.dispatch(grantRecordingConsentAndUnmute())
                : APP.store.dispatch(grantRecordingConsent());
        },
        // @ts-ignore
        'grant-voice-agent-consent': (id, allow = true) => {
            const { agents, consent } = APP.store.getState()['features/voice-agents'];
            // An id that is not a present agent decides nothing (and must not touch an open dialog).
            if (id && !Object.hasOwn(agents, id)) {
                return;
            }
            const ids = id ? [id] : Object.keys(agents).filter(agentId => consent[agentId] !== true);
            ids.forEach(agentId => APP.store.dispatch(allow ? allowVoiceAgent(agentId) : declineVoiceAgent(agentId)));
        },
        // @ts-ignore
        'display-name': displayName => {
            sendAnalytics(createApiEvent('display.name.changed'));
            APP.store.dispatch(updateSettings({ displayName: getNormalizedDisplayName(displayName) }));
        },
        // @ts-ignore
        'local-subject': localSubject => {
            sendAnalytics(createApiEvent('local.subject.changed'));
            APP.store.dispatch(setLocalSubject(localSubject));
        },
        // @ts-ignore
        'mute-everyone': mediaType => {
            const muteMediaType = mediaType ? mediaType : MEDIA_TYPE.AUDIO;
            sendAnalytics(createApiEvent('muted-everyone'));
            const localParticipant = getLocalParticipant(APP.store.getState());
            const exclude = [];
            if (localParticipant && isParticipantModerator(localParticipant)) {
                exclude.push(localParticipant.id);
            }
            APP.store.dispatch(muteAllParticipants(exclude, muteMediaType));
        },
        // @ts-ignore
        'mute-remote-participant': (participantId, mediaType) => {
            const state = APP.store.getState();
            const muteMediaType = mediaType ? mediaType : MEDIA_TYPE.AUDIO;
            const localParticipant = getLocalParticipant(state);
            // Check if targeting the local participant. Always mute here, never toggle, so that
            // repeating the command on an already muted local participant does not unmute them.
            if (participantId === localParticipant?.id) {
                if (muteMediaType === MEDIA_TYPE.AUDIO) {
                    APP.conference.muteAudio(true);
                }
                else if (muteMediaType === MEDIA_TYPE.VIDEO) {
                    APP.conference.muteVideo(true);
                }
                return;
            }
            if (!isLocalParticipantModerator(state)) {
                logger.error('Missing moderator rights to mute remote participant');
                return;
            }
            APP.store.dispatch(muteRemote(participantId, muteMediaType));
        },
        // @ts-ignore
        'toggle-lobby': enabled => {
            APP.store.dispatch(toggleLobbyMode(enabled));
        },
        // @ts-ignore
        'password': password => {
            const { conference, passwordRequired } = APP.store.getState()['features/base/conference'];
            if (passwordRequired) {
                sendAnalytics(createApiEvent('submit.password'));
                APP.store.dispatch(setPassword(passwordRequired, passwordRequired.join, password));
            }
            else {
                sendAnalytics(createApiEvent('password.changed'));
                APP.store.dispatch(setPassword(conference, 
                // @ts-ignore
                conference.lock, password));
            }
        },
        // @ts-ignore
        'pin-participant': (id, videoType) => {
            const state = APP.store.getState();
            // if id not provided, unpin everybody.
            if (!id) {
                if (isStageFilmstripAvailable(state)) {
                    const pinnedParticipants = getPinnedActiveParticipants(state);
                    pinnedParticipants?.forEach(p => {
                        APP.store.dispatch(togglePinStageParticipant(p.participantId));
                    });
                }
                else {
                    APP.store.dispatch(pinParticipant());
                }
                return;
            }
            const participant = videoType === VIDEO_TYPE.DESKTOP
                ? getVirtualScreenshareParticipantByOwnerId(state, id) : getParticipantById(state, id);
            if (!participant) {
                logger.warn('Trying to pin a non-existing participant with pin-participant command.');
                return;
            }
            sendAnalytics(createApiEvent('participant.pinned'));
            const participantId = participant.id;
            if (isStageFilmstripAvailable(state)) {
                APP.store.dispatch(addStageParticipant(participantId, true));
            }
            else {
                APP.store.dispatch(pinParticipant(participantId));
            }
        },
        // @ts-ignore
        'proxy-connection-event': event => {
            APP.conference.onProxyConnectionEvent(event);
        },
        // @ts-ignore
        'external-share-signal': signal => {
            // Direct-cast screenshare — a plain RTCPeerConnection signalling message
            // from a remote sharer, the successor to 'proxy-connection-event'. See
            // conference.onExternalShareSignal.
            APP.conference.onExternalShareSignal(signal);
        },
        // @ts-ignore
        'reject-participant': (participantId, mediaType) => {
            if (!isLocalParticipantModerator(APP.store.getState())) {
                return;
            }
            const reject = mediaType === MEDIA_TYPE.VIDEO ? rejectParticipantVideo : rejectParticipantAudio;
            APP.store.dispatch(reject(participantId));
        },
        // @ts-ignore
        'remove-breakout-room': breakoutRoomJid => {
            if (!isLocalParticipantModerator(APP.store.getState())) {
                logger.error('Missing moderator rights to remove breakout rooms');
                return;
            }
            APP.store.dispatch(removeBreakoutRoom(breakoutRoomJid));
        },
        // @ts-ignore
        'resize-large-video': (width, height) => {
            sendAnalytics(createApiEvent('largevideo.resized'));
            APP.store.dispatch(resizeLargeVideo(width, height));
        },
        'send-tones': (options = {}) => {
            // @ts-ignore
            const { duration, tones, pause } = options;
            APP.store.dispatch(sendTones(tones, duration, pause));
        },
        // @ts-ignore
        'set-assumed-bandwidth-bps': value => {
            logger.debug('Set assumed bandwidth bps command received', value);
            if (typeof value !== 'number' || isNaN(value)) {
                logger.error('Assumed bandwidth bps must be a number.');
                return;
            }
            APP.store.dispatch(setAssumedBandwidthBps(value));
        },
        // @ts-ignore
        'set-blurred-background': blurType => {
            const tracks = APP.store.getState()['features/base/tracks'];
            const videoTrack = getLocalVideoTrack(tracks)?.vietmeetTrack;
            const muted = tracks ? isLocalTrackMuted(tracks, MEDIA_TYPE.VIDEO) : isVideoMutedByUser(APP.store);
            APP.store.dispatch(toggleBlurredBackgroundEffect(videoTrack, blurType, muted));
        },
        // @ts-ignore
        'set-follow-me': (value, recorderOnly) => {
            if (value) {
                sendAnalytics(createApiEvent('follow.me.set', {
                    recorderOnly
                }));
            }
            else {
                sendAnalytics(createApiEvent('follow.me.unset', {
                    recorderOnly
                }));
            }
            APP.store.dispatch(recorderOnly ? setFollowMeRecorder(value) : setFollowMe(value));
        },
        // @ts-ignore
        'set-large-video-participant': (participantId, videoType) => {
            const { getState, dispatch } = APP.store;
            if (!participantId) {
                sendAnalytics(createApiEvent('largevideo.participant.set'));
                dispatch(selectParticipantInLargeVideo());
                return;
            }
            const state = getState();
            const participant = videoType === VIDEO_TYPE.DESKTOP
                ? getVirtualScreenshareParticipantByOwnerId(state, participantId)
                : getParticipantById(state, participantId);
            if (!participant) {
                logger.warn('Trying to select a non-existing participant with set-large-video-participant command.');
                return;
            }
            dispatch(setTileView(false));
            sendAnalytics(createApiEvent('largevideo.participant.set'));
            dispatch(selectParticipantInLargeVideo(participant.id));
        },
        // @ts-ignore
        'set-participant-properties': (properties, useRawKeys = false) => {
            APP.conference.setLocalParticipantProperties(properties, useRawKeys);
        },
        // @ts-ignore
        'set-participant-volume': (participantId, volume) => {
            APP.store.dispatch(setVolume(participantId, volume));
        },
        // @ts-ignore
        'subject': subject => {
            sendAnalytics(createApiEvent('subject.changed'));
            APP.store.dispatch(setSubject(subject));
        },
        // @ts-ignore
        'submit-feedback': feedback => {
            sendAnalytics(createApiEvent('submit.feedback'));
            APP.conference.submitFeedback(feedback.score, feedback.message);
        },
        'toggle-audio': () => {
            sendAnalytics(createApiEvent('toggle-audio'));
            APP.conference.toggleAudioMuted(false /* no UI */);
        },
        'toggle-video': () => {
            sendAnalytics(createApiEvent('toggle-video'));
            APP.conference.toggleVideoMuted(false /* no UI */, true /* ensure track */);
        },
        'toggle-film-strip': () => {
            sendAnalytics(createApiEvent('film.strip.toggled'));
            const { visible } = APP.store.getState()['features/filmstrip'];
            APP.store.dispatch(setFilmstripVisible(!visible));
        },
        /*
         * @param {Object} options - Additional details of how to perform
         * the action.
         * @param {number} options.width - width value for film strip.
         */
        'resize-film-strip': (options = {}) => {
            sendAnalytics(createApiEvent('film.strip.resize'));
            // @ts-ignore
            APP.store.dispatch(resizeFilmStrip(options.width));
        },
        // @ts-ignore
        'toggle-camera': facingMode => {
            APP.store.dispatch(setCameraFacingMode(facingMode));
        },
        'toggle-camera-mirror': () => {
            const state = APP.store.getState();
            const { localFlipX: currentFlipX } = state['features/base/settings'];
            APP.store.dispatch(updateSettings({ localFlipX: !currentFlipX }));
        },
        'toggle-chat': () => {
            sendAnalytics(createApiEvent('chat.toggled'));
            APP.store.dispatch(toggleChat());
        },
        // @ts-ignore
        'toggle-moderation': (enabled, mediaType) => {
            const state = APP.store.getState();
            if (!isLocalParticipantModerator(state)) {
                return;
            }
            const enable = mediaType === MEDIA_TYPE.VIDEO
                ? requestEnableVideoModeration : requestEnableAudioModeration;
            const disable = mediaType === MEDIA_TYPE.VIDEO
                ? requestDisableVideoModeration : requestDisableAudioModeration;
            if (enabled) {
                APP.store.dispatch(enable());
            }
            else {
                APP.store.dispatch(disable());
            }
        },
        // @ts-ignore
        'toggle-participants-pane': enabled => {
            const toggleParticipantsPane = enabled
                ? openParticipantsPane : closeParticipantsPane;
            APP.store.dispatch(toggleParticipantsPane());
        },
        'toggle-raise-hand': () => {
            const localParticipant = getLocalParticipant(APP.store.getState());
            if (!localParticipant) {
                return;
            }
            const raisedHand = hasRaisedHand(localParticipant);
            sendAnalytics(createApiEvent('raise-hand.toggled'));
            APP.store.dispatch(raiseHand(!raisedHand));
        },
        'toggle-share-audio': () => {
            sendAnalytics(createApiEvent('audio.screen.sharing.toggled'));
            if (isScreenAudioSupported()) {
                APP.store.dispatch(startAudioScreenShareFlow());
                return;
            }
            logger.error('Audio screen sharing is not supported by the current platform!');
        },
        /**
         * Callback to invoke when the "toggle-share-screen" command is received.
         *
         * @param {Object} options - Additional details of how to perform
         * the action. Note this parameter is undocumented and experimental.
         * @param {boolean} options.enable - Whether trying to enable screen
         * sharing or to turn it off.
         * @returns {void}
         */
        'toggle-share-screen': (options = {}) => {
            sendAnalytics(createApiEvent('screen.sharing.toggled'));
            // @ts-ignore
            toggleScreenSharing(options.enable);
        },
        'set-meeting-timer': (options = {}) => {
            sendAnalytics(createApiEvent('meeting.timer.set'));
            APP.store.dispatch(setMeetingTimer(options));
        },
        'set-noise-suppression-enabled': (options = {}) => {
            // @ts-ignore
            APP.store.dispatch(setNoiseSuppressionEnabled(options.enabled));
        },
        'toggle-subtitles': () => {
            APP.store.dispatch(toggleRequestingSubtitles());
        },
        // @ts-ignore
        'set-subtitles': (enabled, displaySubtitles, language) => {
            APP.store.dispatch(setRequestingSubtitles(enabled, displaySubtitles, language ? `translation-languages:${language}` : null));
        },
        'toggle-tile-view': () => {
            sendAnalytics(createApiEvent('tile-view.toggled'));
            APP.store.dispatch(toggleTileView());
        },
        'set-second-screen': (options = {}) => {
            // @ts-ignore
            APP.store.dispatch(setSecondScreen(options.id ?? 'default', options.source, options.screen));
        },
        // @ts-ignore
        'set-tile-view': enabled => {
            APP.store.dispatch(setTileView(enabled));
        },
        'video-hangup': (showFeedbackDialog = true) => {
            sendAnalytics(createApiEvent('video.hangup'));
            APP.conference.hangup(showFeedbackDialog);
        },
        // @ts-ignore
        'email': email => {
            sendAnalytics(createApiEvent('email.changed'));
            APP.conference.changeLocalEmail(email);
        },
        // @ts-ignore
        'avatar-url': avatarUrl => {
            console.warn('Using command avatarUrl is deprecated. Use context.user.avatar in the jwt.');
            sendAnalytics(createApiEvent('avatar.url.changed'));
            APP.conference.changeLocalAvatarUrl(avatarUrl);
        },
        // @ts-ignore
        'send-chat-message': (message, to, ignorePrivacy = false) => {
            if (to) {
                const participant = getParticipantById(APP.store.getState(), to);
                if (participant) {
                    APP.store.dispatch(setPrivateMessageRecipient(participant));
                }
                else {
                    logger.error(`Participant with id ${to} not found!`);
                    return;
                }
            }
            else {
                APP.store.dispatch(setPrivateMessageRecipient());
            }
            APP.store.dispatch(sendMessage(message, ignorePrivacy));
        },
        // @ts-ignore
        'send-endpoint-text-message': (to, text) => {
            try {
                APP.conference.sendEndpointMessage(to, {
                    name: ENDPOINT_TEXT_MESSAGE_NAME,
                    text
                });
            }
            catch (err) {
                logger.error('Failed sending endpoint text message', err);
            }
        },
        // @ts-ignore
        'send-camera-facing-mode-message': (to, facingMode) => {
            if (!to) {
                logger.warn('Participant id not set');
                return;
            }
            APP.conference.sendEndpointMessage(to, {
                name: CAMERA_FACING_MODE_MESSAGE,
                facingMode
            });
        },
        // @ts-ignore
        'overwrite-names': participantList => {
            APP.store.dispatch(overwriteParticipantsNames(participantList));
        },
        // @ts-ignore
        'toggle-e2ee': enabled => {
            const blockingService = enabled && getE2EEBlockingService(APP.store.getState());
            if (blockingService) {
                logger.warn(`Not turning on end-to-end encryption while ${blockingService} is in use`);
                return;
            }
            APP.store.dispatch(toggleE2EE(enabled));
        },
        // @ts-ignore
        'set-media-encryption-key': keyInfo => {
            APP.store.dispatch(setMediaEncryptionKey(JSON.parse(keyInfo)));
        },
        // @ts-ignore
        'set-video-quality': frameHeight => {
            sendAnalytics(createApiEvent('set.video.quality'));
            APP.store.dispatch(setVideoQuality(frameHeight));
        },
        // @ts-ignore
        'set-low-bandwidth-mode': enable => {
            sendAnalytics(createApiEvent('set.low.bandwidth.mode'));
            APP.store.dispatch(setLowBandwidthMode(enable));
        },
        // @ts-ignore
        'start-share-video': url => {
            sendAnalytics(createApiEvent('share.video.start'));
            const id = extractYoutubeIdOrURL(url);
            if (id) {
                APP.store.dispatch(playSharedVideo(id));
            }
        },
        'stop-share-video': () => {
            sendAnalytics(createApiEvent('share.video.stop'));
            APP.store.dispatch(stopSharedVideo());
        },
        /**
         * Shows a custom in-meeting notification.
         *
         * @param { string } arg.title - Notification title.
         * @param { string } arg.description - Notification description.
         * @param { string } arg.uid - Optional unique identifier for the notification.
         * @param { string } arg.type - Notification type, either `error`, `normal`, `success` or `warning`.
         * Defaults to "normal" if not provided.
         * @param { string } arg.timeout - Timeout type, either `short`, `medium`, `long` or `sticky`.
         * Defaults to "short" if not provided.
         * @param { Array<Object> } arg.customActions - An array of custom actions to be displayed in the notification.
         * Each object should have a `label` and a `uuid` property. It should be used along a listener
         * for the `customNotificationActionTriggered` event to handle the custom action.
         * @returns {void}
         */
        'show-notification': ({ customActions = [], 
        // @ts-ignore
        title, 
        // @ts-ignore
        description, 
        // @ts-ignore
        uid, type = NOTIFICATION_TYPE.NORMAL, timeout = NOTIFICATION_TIMEOUT_TYPE.SHORT }) => {
            const validTypes = Object.values(NOTIFICATION_TYPE);
            const validTimeouts = Object.values(NOTIFICATION_TIMEOUT_TYPE);
            if (!validTypes.includes(type)) {
                logger.error(`Invalid notification type "${type}". Expecting one of ${validTypes}`);
                return;
            }
            if (!validTimeouts.includes(timeout)) {
                logger.error(`Invalid notification timeout "${timeout}". Expecting one of ${validTimeouts}`);
                return;
            }
            const handlers = customActions.map(({ uuid }) => () => {
                APP.API.notifyCustomNotificationActionTriggered(uuid);
            });
            const keys = customActions.map(({ label }) => label);
            APP.store.dispatch(showNotification({
                customActionHandler: handlers,
                customActionNameKey: keys,
                uid,
                title,
                description,
                appearance: type
            }, timeout));
        },
        /**
         * Removes a notification given a unique identifier.
         *
         * @param { string } uid - Unique identifier for the notification to be removed.
         * @returns {void}
         */
        // @ts-ignore
        'hide-notification': uid => {
            APP.store.dispatch(hideNotification(uid));
        },
        /**
         * Starts a file recording or streaming session depending on the passed on params.
         * For RTMP streams, `rtmpStreamKey` must be passed on. `rtmpBroadcastID` is optional.
         * For youtube streams, `youtubeStreamKey` must be passed on. `youtubeBroadcastID` is optional.
         * For dropbox recording, recording `mode` should be `file` and a dropbox oauth2 token must be provided.
         * For file recording, recording `mode` should be `file` and optionally `shouldShare` could be passed on.
         * For local recording, recording `mode` should be `local` and optionally `onlySelf` could be passed on.
         * No other params should be passed.
         *
         * @param { string } arg.mode - Recording mode, either `local`, `file` or `stream`.
         * @param { string } arg.dropboxToken - Dropbox oauth2 token.
         * @param { boolean } arg.onlySelf - Whether to only record the local streams.
         * @param { string } arg.rtmpStreamKey - The RTMP stream key.
         * @param { string } arg.rtmpBroadcastID - The RTMP broadcast ID.
         * @param { boolean } arg.shouldShare - Whether the recording should be shared with the participants or not.
         * Only applies to certain vietmeet meet deploys.
         * @param { string } arg.youtubeStreamKey - The youtube stream key.
         * @param { string } arg.youtubeBroadcastID - The youtube broadcast ID.
         * @param { Object } arg.extraMetadata - Any extra metadata params for file recording.
         * @param { boolean } arg.transcription - Whether a transcription should be started or not.
         * @returns {void}
         */
        'start-recording': ({ 
        // @ts-ignore
        mode, 
        // @ts-ignore
        dropboxToken, 
        // @ts-ignore
        onlySelf, 
        // @ts-ignore
        shouldShare, 
        // @ts-ignore
        rtmpStreamKey, 
        // @ts-ignore
        rtmpBroadcastID, 
        // @ts-ignore
        youtubeStreamKey, 
        // @ts-ignore
        youtubeBroadcastID, extraMetadata = {}, 
        // @ts-ignore
        transcription }) => {
            const state = APP.store.getState();
            const conference = getCurrentConference(state);
            if (!conference) {
                logger.error('Conference is not defined');
                return;
            }
            if (dropboxToken && !isDropboxEnabled(state)) {
                logger.error('Failed starting recording: dropbox is not enabled on this deployment');
                return;
            }
            if (mode === VietMeetRecordingConstants.mode.STREAM && !(youtubeStreamKey || rtmpStreamKey)) {
                logger.error('Failed starting recording: missing youtube or RTMP stream key');
                return;
            }
            if (mode === 'local') {
                const { localRecording } = state['features/base/config'];
                if (!localRecording?.disable && supportsLocalRecording()) {
                    APP.store.dispatch(startLocalVideoRecording(onlySelf));
                }
                else {
                    logger.error('Failed starting recording: local recording is either disabled or not supported');
                }
                return;
            }
            let recordingConfig;
            if (mode === VietMeetRecordingConstants.mode.FILE) {
                const { recordingService } = state['features/base/config'];
                // @ts-ignore
                if (!recordingService.enabled && !dropboxToken) {
                    logger.error('Failed starting recording: the recording service is not enabled');
                    return;
                }
                if (dropboxToken) {
                    recordingConfig = {
                        mode: VietMeetRecordingConstants.mode.FILE,
                        appData: JSON.stringify({
                            'file_recording_metadata': {
                                ...extraMetadata,
                                'upload_credentials': {
                                    'service_name': RECORDING_TYPES.DROPBOX,
                                    'token': dropboxToken
                                }
                            }
                        })
                    };
                }
                else {
                    recordingConfig = {
                        mode: VietMeetRecordingConstants.mode.FILE,
                        appData: JSON.stringify({
                            'file_recording_metadata': {
                                ...extraMetadata,
                                'share': shouldShare
                            }
                        })
                    };
                }
            }
            else if (mode === VietMeetRecordingConstants.mode.STREAM) {
                recordingConfig = {
                    broadcastId: youtubeBroadcastID || rtmpBroadcastID,
                    mode: VietMeetRecordingConstants.mode.STREAM,
                    streamId: youtubeStreamKey || rtmpStreamKey
                };
            }
            if (isScreenshotCaptureEnabled(state, true, false)) {
                APP.store.dispatch(toggleScreenshotCaptureSummary(true));
            }
            const wantsRecording = mode === VietMeetRecordingConstants.mode.FILE;
            const wantsTranscription = Boolean(transcription);
            // Seed startRecordingIntent so maybeNotifyRecordingStart can coordinate
            // the start sound/notification once recording (and transcription, if
            // requested) resolve. Without this, notifyRecordingLinkAvailable is
            // never emitted for iFrame-initiated recordings.
            if (wantsRecording || wantsTranscription) {
                APP.store.dispatch(setStartRecordingIntent({
                    recording: wantsRecording,
                    transcription: wantsTranscription
                }));
            }
            // Start audio / video recording, if requested.
            if (typeof recordingConfig !== 'undefined') {
                conference.startRecording(recordingConfig);
            }
            // Update room metadata so remote participants see the combined
            // recording/transcription intent. When transcription is requested,
            // setRequestingSubtitles routes through the subtitles middleware
            // which writes both metadata fields atomically; otherwise we write
            // the recording-only metadata directly, mirroring the start dialog.
            if (wantsTranscription) {
                APP.store.dispatch(setRequestingSubtitles(true, false, null, true, wantsRecording));
            }
            else if (wantsRecording) {
                conference.getMetadataHandler().setMetadata(RECORDING_METADATA_ID, {
                    isRecordingRequested: true,
                    isTranscribingEnabled: false
                });
            }
        },
        /**
         * Stops a recording or streaming in progress.
         *
         * @param {string} mode - `local`, `file` or `stream`.
         * @param {boolean} transcription - Whether the transcription needs to be stopped.
         * @returns {void}
         */
        // @ts-ignore
        'stop-recording': (mode, transcription) => {
            const state = APP.store.getState();
            const conference = getCurrentConference(state);
            if (!conference) {
                logger.error('Conference is not defined');
                return;
            }
            if (mode === 'local') {
                if (transcription) {
                    APP.store.dispatch(setRequestingSubtitles(false, false, null, true));
                }
                APP.store.dispatch(stopLocalVideoRecording());
                return;
            }
            if (![VietMeetRecordingConstants.mode.FILE, VietMeetRecordingConstants.mode.STREAM].includes(mode)) {
                logger.error('Invalid recording mode provided!');
                return;
            }
            const activeSession = getActiveSession(state, mode);
            const wantsStopRecording = mode === VietMeetRecordingConstants.mode.FILE && Boolean(activeSession);
            const wantsStopTranscription = Boolean(transcription);
            // Seed stopRecordingIntent so maybeNotifyRecordingStop can coordinate
            // the off sound/notification across recording and transcription stops.
            if (wantsStopRecording || wantsStopTranscription) {
                APP.store.dispatch(setStopRecordingIntent({
                    recording: wantsStopRecording,
                    transcription: wantsStopTranscription
                }));
            }
            if (wantsStopTranscription) {
                APP.store.dispatch(setRequestingSubtitles(false, false, null, true));
            }
            // Mirror AbstractStopRecordingDialog — clear both fields atomically so
            // remote clients see the end of the recording/transcription intent.
            // Covers recording-only, transcription-only, and combined stops.
            if (wantsStopRecording || wantsStopTranscription) {
                conference.getMetadataHandler().setMetadata(RECORDING_METADATA_ID, {
                    isRecordingRequested: false,
                    isTranscribingEnabled: false
                });
            }
            APP.store.dispatch(toggleScreenshotCaptureSummary(false));
            conference.stopRecording(activeSession?.id);
        },
        // @ts-ignore
        'initiate-private-chat': participantId => {
            const state = APP.store.getState();
            const participant = getParticipantById(state, participantId);
            if (participant) {
                const { isOpen: isChatOpen } = state['features/chat'];
                if (!isChatOpen) {
                    APP.store.dispatch(toggleChat());
                }
                APP.store.dispatch(openChat(participant));
            }
            else {
                logger.error('No participant found for the given participantId');
            }
        },
        'cancel-private-chat': () => {
            APP.store.dispatch(setPrivateMessageRecipient());
        },
        // @ts-ignore
        'close-breakout-room': roomId => {
            if (!isLocalParticipantModerator(APP.store.getState())) {
                logger.error('Missing moderator rights to close breakout rooms');
                return;
            }
            APP.store.dispatch(closeBreakoutRoom(roomId));
        },
        // @ts-ignore
        'join-breakout-room': roomId => {
            APP.store.dispatch(moveToRoom(roomId));
        },
        // @ts-ignore
        'send-participant-to-room': (participantId, roomId) => {
            if (!isLocalParticipantModerator(APP.store.getState())) {
                logger.error('Missing moderator rights to send participants to rooms');
                return;
            }
            APP.store.dispatch(sendParticipantToRoom(participantId, roomId));
        },
        // @ts-ignore
        'kick-participant': participantId => {
            APP.store.dispatch(kickParticipant(participantId));
        },
        // @ts-ignore
        'overwrite-config': config => {
            const whitelistedConfig = getWhitelistedJSON('config', config);
            logger.info(`Overwriting config with: ${JSON.stringify(whitelistedConfig)}`);
            APP.store.dispatch(overwriteConfig(whitelistedConfig));
        },
        'toggle-virtual-background': () => {
            APP.store.dispatch(toggleDialog('SettingsDialog', SettingsDialog, {
                defaultTab: SETTINGS_TABS.VIRTUAL_BACKGROUND
            }));
        },
        'end-conference': () => {
            const state = APP.store.getState();
            const conference = getCurrentConference(state);
            if (!conference) {
                logger.error('Conference not yet available');
            }
            else if (conference.isEndConferenceSupported()) {
                APP.store.dispatch(endConference());
            }
            else {
                logger.error(' End Conference not supported');
            }
        },
        // @ts-ignore
        'toggle-whiteboard': open => {
            APP.store.dispatch(toggleWhiteboard(open));
        },
        // @ts-ignore
        'set-virtual-background': (enabled, backgroundImage) => {
            const tracks = APP.store.getState()['features/base/tracks'];
            const vietmeetTrack = getLocalVideoTrack(tracks)?.vietmeetTrack;
            APP.store.dispatch(toggleBackgroundEffect({
                backgroundEffectEnabled: enabled,
                backgroundType: VIRTUAL_BACKGROUND_TYPE.IMAGE,
                virtualSource: backgroundImage
            }, vietmeetTrack));
        },
        'show-pip': () => {
            APP.store.dispatch(showPiP());
        },
        'hide-pip': () => {
            APP.store.dispatch(hidePiP());
        },
        'document-pip-opened': () => {
            APP.store.dispatch(handleHostDocumentPiPOpened());
        },
        'document-pip-open-failed': () => {
            APP.store.dispatch(handleHostDocumentPiPOpenFailed());
        },
        'document-pip-closed': () => {
            APP.store.dispatch(handleHostDocumentPiPWindowClosed());
        },
        // @ts-ignore
        'document-pip-signal': signal => {
            APP.store.dispatch(handleHostDocumentPiPSignal(signal));
        }
    };
    // @ts-ignore
    transport.on('event', ({ data, name }) => {
        // @ts-ignore
        if (name && commands[name]) {
            logger.info(`API command received: ${name}`);
            // @ts-ignore
            commands[name](...data);
            return true;
        }
        return false;
    });
    // @ts-ignore
    transport.on('request', (request, callback) => {
        const { dispatch, getState } = APP.store;
        if (processExternalDeviceRequest(dispatch, getState, request, callback)) {
            return true;
        }
        const { name } = request;
        switch (name) {
            case 'capture-largevideo-screenshot':
                APP.store.dispatch(captureLargeVideoScreenshot())
                    .then(dataURL => {
                    let error;
                    if (!dataURL) {
                        error = new Error('No large video found!');
                    }
                    callback({
                        error,
                        dataURL
                    });
                });
                break;
            case 'capture-camera-picture': {
                const { cameraFacingMode, descriptionText, titleText } = request;
                if (!isMobileBrowser()) {
                    logger.error('This feature is only supported on mobile');
                    return;
                }
                APP.store.dispatch(openCameraCaptureDialog(callback, { cameraFacingMode,
                    descriptionText,
                    titleText }));
                break;
            }
            case 'connection-stats': {
                callback({
                    ...APP.conference.getStats(),
                    iceConnected: APP.conference.getConnectionState() === 'connected'
                });
                break;
            }
            case 'deployment-info':
                callback(APP.store.getState()['features/base/config'].deploymentInfo);
                break;
            case 'invite': {
                const { invitees } = request;
                if (!Array.isArray(invitees) || invitees.length === 0) {
                    callback({
                        error: new Error('Unexpected format of invitees')
                    });
                    break;
                }
                // The store should be already available because API.init is called
                // on appWillMount action.
                APP.store.dispatch(invite(invitees, true))
                    .then(failedInvitees => {
                    let error;
                    let result;
                    if (failedInvitees.length) {
                        error = new Error('One or more invites failed!');
                    }
                    else {
                        result = true;
                    }
                    callback({
                        error,
                        result
                    });
                });
                break;
            }
            case 'is-audio-muted':
                callback(APP.conference.isLocalAudioMuted());
                break;
            case 'is-audio-disabled':
                callback(isAudioMuteButtonDisabled(APP.store.getState()));
                break;
            case 'is-moderation-on': {
                const { mediaType } = request;
                const type = mediaType || MEDIA_TYPE.AUDIO;
                callback(isEnabledFromState(type, APP.store.getState()));
                break;
            }
            case 'is-participant-force-muted': {
                const state = APP.store.getState();
                const { participantId, mediaType } = request;
                const type = mediaType || MEDIA_TYPE.AUDIO;
                const participant = getParticipantById(state, participantId);
                callback(isForceMuted(participant, type, state));
                break;
            }
            case 'is-participants-pane-open': {
                callback(getParticipantsPaneOpen(APP.store.getState()));
                break;
            }
            case 'is-video-muted':
                callback(APP.conference.isLocalVideoMuted());
                break;
            case 'is-audio-available':
                callback(audioAvailable);
                break;
            case 'is-video-available':
                callback(videoAvailable);
                break;
            case 'is-sharing-screen':
                callback(Boolean(APP.conference.isSharingScreen));
                break;
            case 'is-lobby-enabled':
                callback(Boolean(getLobbyEnabled(APP.store.getState())));
                break;
            case 'is-start-silent':
                callback(Boolean(APP.store.getState()['features/base/config'].startSilent));
                break;
            case 'get-content-sharing-participants': {
                const sharingParticipantIds = getScreenshareParticipantIds(APP.store.getState());
                callback({
                    sharingParticipantIds
                });
                break;
            }
            case 'get-livestream-url': {
                const state = APP.store.getState();
                const conference = getCurrentConference(state);
                let livestreamUrl;
                if (conference) {
                    const activeSession = getActiveSession(state, VietMeetRecordingConstants.mode.STREAM);
                    livestreamUrl = activeSession?.liveStreamViewURL;
                }
                else {
                    logger.error('Conference is not defined');
                }
                callback({
                    livestreamUrl
                });
                break;
            }
            case 'get-custom-avatar-backgrounds': {
                callback({
                    avatarBackgrounds: APP.store.getState()['features/dynamic-branding'].avatarBackgrounds
                });
                break;
            }
            case 'list-breakout-rooms': {
                callback(getBreakoutRooms(APP.store.getState()));
                break;
            }
            case 'rooms-info': {
                const { includeHidden } = request;
                callback(getRoomsInfo(APP.store.getState(), includeHidden));
                break;
            }
            case 'get-shared-document-url': {
                // @ts-ignore
                const { etherpad } = APP.store.getState()['features/etherpad'];
                callback(etherpad?.documentUrl || '');
                break;
            }
            case 'get-p2p-status': {
                callback(isP2pActive(APP.store.getState()));
                break;
            }
            case 'session-id': {
                const { conference } = APP.store.getState()['features/base/conference'];
                callback(conference?.getMeetingUniqueId() || '');
                break;
            }
            case '_new_electron_screensharing_supported': {
                callback(true);
                break;
            }
            case 'open-desktop-picker': {
                const { desktopSharingSources } = APP.store.getState()['features/base/config'];
                const options = {
                    desktopSharingSources: desktopSharingSources ?? ['screen', 'window']
                };
                // @ts-ignore
                const onSourceChoose = (_streamId, _type, screenShareAudio, source) => {
                    callback({
                        screenShareAudio,
                        source
                    });
                };
                dispatch(showDesktopPicker(options, onSourceChoose));
                break;
            }
            default:
                callback({ error: new Error('UnknownRequestError') });
                return false;
        }
        return true;
    });
}
/**
 * Check whether the API should be enabled or not.
 *
 * @returns {boolean}
 */
function shouldBeEnabled() {
    return (typeof API_ID === 'number'
        // XXX Enable the API when a JSON Web Token (JWT) is specified in
        // the location/URL because then it is very likely that the VietMeet
        // Meet (Web) app is being used by an external/wrapping (Web) app
        // and, consequently, the latter will need to communicate with the
        // former. (The described logic is merely a heuristic though.)
        || parseJWTFromURLParams());
}
/**
 * Executes on toggle-share-screen command.
 *
 * @param {boolean} [enable] - Whether this toggle is to explicitly enable or
 * disable screensharing. If not defined, the application will automatically
 * attempt to toggle between enabled and disabled. This boolean is useful for
 * explicitly setting desired screensharing state.
 * @returns {void}
 */
// @ts-ignore
function toggleScreenSharing(enable) {
    if (VietMeetJS.isDesktopSharingEnabled()) {
        APP.store.dispatch(startScreenShareFlow(enable));
    }
}
/**
 * Removes sensitive data from a mouse event.
 *
 * @param {MouseEvent} event - The mouse event to sanitize.
 * @returns {Object}
 */
// @ts-ignore
function sanitizeMouseEvent(event) {
    const { clientX, clientY, movementX, movementY, offsetX, offsetY, pageX, pageY, x, y, screenX, screenY } = event;
    return {
        clientX,
        clientY,
        movementX,
        movementY,
        offsetX,
        offsetY,
        pageX,
        pageY,
        x,
        y,
        screenX,
        screenY
    };
}
/**
 * Implements API class that communicates with external API class and provides
 * interface to access VietMeet Meet features by external applications that embed
 * VietMeet Meet.
 */
class API {
    // @ts-ignore
    _enabled;
    /**
     * Initializes the API. Setups message event listeners that will receive
     * information from external applications that embed VietMeet Meet. It also
     * sends a message to the external application that API is initialized.
     *
     * @param {Object} options - Optional parameters.
     * @returns {void}
     */
    init() {
        if (!shouldBeEnabled()) {
            return;
        }
        /**
         * Current status (enabled/disabled) of API.
         *
         * @private
         * @type {boolean}
         */
        this._enabled = true;
        initCommands();
        this.notifyBrowserSupport(isSupportedBrowser());
        // Let the embedder know we are ready.
        this._sendEvent({ name: 'ready' });
    }
    /**
     * Notify external application (if API is enabled) that the large video
     * visibility changed.
     *
     * @param {boolean} isHidden - True if the large video is hidden and false
     * otherwise.
     * @returns {void}
     */
    // @ts-ignore
    notifyLargeVideoVisibilityChanged(isHidden) {
        this._sendEvent({
            name: 'large-video-visibility-changed',
            isVisible: !isHidden
        });
    }
    /**
     * Notify external application (if API is enabled) that the in-page toolbox
     * visibility changed.
     *
     * @param {boolean} visible - True if the toolbox is visible, false otherwise.
     * @returns {void}
     */
    // @ts-ignore
    notifyToolbarVisibilityChanged(visible) {
        this._sendEvent({
            name: 'toolbar-visibility-changed',
            visible
        });
    }
    /**
     * Notifies the external application (spot) that the local vietmeet-participant
     * has a status update.
     *
     * @param {Object} event - The message to pass onto spot.
     * @returns {void}
     */
    // @ts-ignore
    sendProxyConnectionEvent(event) {
        this._sendEvent({
            name: 'proxy-connection-event',
            ...event
        });
    }
    /**
     * Notifies the external application (the sharer, via the embedder) of a direct-cast
     * screenshare signalling message (answer / ICE candidate). The successor to
     * {@link sendProxyConnectionEvent}; plain SDP/ICE, no Jingle.
     *
     * @param {Object} signal - The signalling message to pass back to the sharer.
     * @returns {void}
     */
    // @ts-ignore
    sendExternalShareSignal(signal) {
        this._sendEvent({
            name: 'external-share-signal',
            signal
        });
    }
    /**
     * Sends event to the external application.
     *
     * @param {Object} event - The event to be sent.
     * @returns {void}
     */
    _sendEvent(event = {}) {
        if (this._enabled) {
            try {
                transport.sendEvent(event);
            }
            catch (error) {
                logger.error('Failed to send and IFrame API event', error);
            }
        }
    }
    /**
     * Notify external application (if API is enabled) that the chat state has been updated.
     *
     * @param {number} unreadCount - The unread messages counter.
     * @param {boolean} isOpen - True if the chat panel is open.
     * @returns {void}
     */
    // @ts-ignore
    notifyChatUpdated(unreadCount, isOpen) {
        this._sendEvent({
            name: 'chat-updated',
            unreadCount,
            isOpen
        });
    }
    /**
     * Notify external application (if API is enabled) that message was sent.
     *
     * @param {string} message - Message body.
     * @param {boolean} privateMessage - True if the message was a private message.
     * @returns {void}
     */
    // @ts-ignore
    notifySendingChatMessage(message, privateMessage) {
        this._sendEvent({
            name: 'outgoing-message',
            message,
            privateMessage
        });
    }
    /**
     * Notify external application (if API is enabled) that the mouse has entered inside the iframe.
     *
     * @param {MouseEvent} event - The mousemove event.
     * @returns {void}
     */
    // @ts-ignore
    notifyMouseEnter(event) {
        this._sendEvent({
            name: 'mouse-enter',
            event: sanitizeMouseEvent(event)
        });
    }
    /**
     * Notify external application (if API is enabled) that the mouse has entered inside the iframe.
     *
     * @param {MouseEvent} event - The mousemove event.
     * @returns {void}
     */
    // @ts-ignore
    notifyMouseLeave(event) {
        this._sendEvent({
            name: 'mouse-leave',
            event: sanitizeMouseEvent(event)
        });
    }
    /**
     * Notify external application (if API is enabled) that the mouse has moved inside the iframe.
     *
     * @param {MouseEvent} event - The mousemove event.
     * @returns {void}
     */
    // @ts-ignore
    notifyMouseMove(event) {
        this._sendEvent({
            name: 'mouse-move',
            event: sanitizeMouseEvent(event)
        });
    }
    /**
     * Notify the external application that the moderation status has changed.
     *
     * @param {string} mediaType - Media type for which the moderation changed.
     * @param {boolean} enabled - Whether or not the new moderation status is enabled.
     * @returns {void}
     */
    // @ts-ignore
    notifyModerationChanged(mediaType, enabled) {
        this._sendEvent({
            name: 'moderation-status-changed',
            mediaType,
            enabled
        });
    }
    /**
     * Notify the external application that the lobby mode status has changed.
     *
     * @param {boolean} enabled - Whether or not lobby mode is enabled.
     * @returns {void}
     */
    // @ts-ignore
    notifyLobbyModeChanged(enabled) {
        this._sendEvent({
            name: 'lobby-mode-changed',
            enabled
        });
    }
    /**
     * Notify the external application that a participant was approved on moderation.
     *
     * @param {string} participantId - The ID of the participant that got approved.
     * @param {string} mediaType - Media type for which the participant was approved.
     * @returns {void}
     */
    // @ts-ignore
    notifyParticipantApproved(participantId, mediaType) {
        this._sendEvent({
            name: 'moderation-participant-approved',
            id: participantId,
            mediaType
        });
    }
    /**
     * Notify the external application that a participant was rejected on moderation.
     *
     * @param {string} participantId - The ID of the participant that got rejected.
     * @param {string} mediaType - Media type for which the participant was rejected.
     * @returns {void}
     */
    // @ts-ignore
    notifyParticipantRejected(participantId, mediaType) {
        this._sendEvent({
            name: 'moderation-participant-rejected',
            id: participantId,
            mediaType
        });
    }
    /**
     * Notify the external application that a participant's mute status changed.
     *
     * @param {string} participantId - The ID of the participant.
     * @param {boolean} isMuted - True if muted, false if unmuted.
     * @param {string} mediaType - Media type that was muted ('audio' or 'video').
     * @returns {void}
     */
    // @ts-ignore
    notifyParticipantMuted(participantId, isMuted, mediaType) {
        this._sendEvent({
            name: 'participant-muted',
            id: participantId,
            isMuted,
            mediaType
        });
    }
    /**
     * Notify the external app that a notification has been triggered.
     *
     * @param {string} title - The notification title.
     * @param {string} description - The notification description.
     *
     * @returns {void}
     */
    // @ts-ignore
    notifyNotificationTriggered(title, description) {
        this._sendEvent({
            description,
            name: 'notification-triggered',
            title
        });
    }
    /**
     * Notify request desktop sources.
     *
     * @param {Object} options - Object with the options for desktop sources.
     * @returns {void}
     */
    // @ts-ignore
    requestDesktopSources(options) {
        return transport.sendRequest({
            name: '_request-desktop-sources',
            options
        });
    }
    /**
     * Notify external application that the video quality setting has changed.
     *
     * @param {number} videoQuality - The video quality. The number represents the maximum height of the video streams.
     * @returns {void}
     */
    // @ts-ignore
    notifyVideoQualityChanged(videoQuality) {
        this._sendEvent({
            name: 'video-quality-changed',
            videoQuality
        });
    }
    /**
     * Notify external application (if API is enabled) that message was
     * received.
     *
     * @param {Object} options - Object with the message properties.
     * @returns {void}
     */
    notifyReceivedChatMessage(
    // @ts-ignore
    { body, from, nick, privateMessage, ts, messageId, replyToMessageId } = {}) {
        if (APP.conference.isLocalId(from)) {
            return;
        }
        const event = {
            name: 'incoming-message',
            from,
            message: body,
            nick,
            privateMessage,
            stamp: ts
        };
        if (typeof messageId === 'string' && messageId !== '') {
            // @ts-ignore
            event.messageId = messageId;
        }
        if (typeof replyToMessageId === 'string' && replyToMessageId !== '') {
            // @ts-ignore
            event.replyToMessageId = replyToMessageId;
        }
        this._sendEvent(event);
    }
    /**
     * Notify external application (if API is enabled) that user joined the
     * conference.
     *
     * @param {string} id - User id.
     * @param {Object} props - The display name of the user.
     * @returns {void}
     */
    // @ts-ignore
    notifyUserJoined(id, props) {
        this._sendEvent({
            name: 'participant-joined',
            id,
            ...props
        });
    }
    /**
     * Notify external application (if API is enabled) that user left the
     * conference.
     *
     * @param {string} id - User id.
     * @returns {void}
     */
    // @ts-ignore
    notifyUserLeft(id) {
        this._sendEvent({
            name: 'participant-left',
            id
        });
    }
    /**
     * Notify external application (if API is enabled) that the user role
     * has changed.
     *
     * @param {string} id - User id.
     * @param {string} role - The new user role.
     * @returns {void}
     */
    // @ts-ignore
    notifyUserRoleChanged(id, role) {
        this._sendEvent({
            name: 'participant-role-changed',
            id,
            role
        });
    }
    /**
     * Notify external application (if API is enabled) that user changed their
     * avatar.
     *
     * @param {string} id - User id.
     * @param {string} avatarURL - The new avatar URL of the participant.
     * @returns {void}
     */
    // @ts-ignore
    notifyAvatarChanged(id, avatarURL) {
        this._sendEvent({
            name: 'avatar-changed',
            avatarURL,
            id
        });
    }
    /**
     * Notify external application (if API is enabled) that user received
     * a text message through datachannels.
     *
     * @param {Object} data - The event data.
     * @returns {void}
     */
    // @ts-ignore
    notifyEndpointTextMessageReceived(data) {
        this._sendEvent({
            name: 'endpoint-text-message-received',
            data
        });
    }
    /**
     * Notify external application (if API is enabled) that some face landmark data is available.
     *
     * @param {Object | undefined} faceBox - Detected face(s) bounding box (left, right, width).
     * @param {string} faceExpression - Detected face expression.
     * @returns {void}
     */
    // @ts-ignore
    notifyFaceLandmarkDetected(faceBox, faceExpression) {
        this._sendEvent({
            name: 'face-landmark-detected',
            faceBox,
            faceExpression
        });
    }
    /**
     * Notify external application (if API is enabled) that a custom notification action has been triggered.
     *
     * @param {string} actionUuid - The UUID of the action that has been triggered.
     * @returns {void}
    */
    // @ts-ignore
    notifyCustomNotificationActionTriggered(actionUuid) {
        this._sendEvent({
            name: 'custom-notification-action-triggered',
            data: {
                id: actionUuid
            }
        });
    }
    /**
     * Notify external application (if API is enabled) that the list of sharing participants changed.
     *
     * @param {Object} data - The event data.
     * @returns {void}
     */
    // @ts-ignore
    notifySharingParticipantsChanged(data) {
        this._sendEvent({
            name: 'content-sharing-participants-changed',
            data
        });
    }
    /**
     * Notify external application (if API is enabled) that the device list has
     * changed.
     *
     * @param {Object} devices - The new device list.
     * @returns {void}
     */
    // @ts-ignore
    notifyDeviceListChanged(devices) {
        this._sendEvent({
            name: 'device-list-changed',
            devices
        });
    }
    /**
     * Notify external application (if API is enabled) that user changed their
     * nickname.
     *
     * @param {string} id - User id.
     * @param {string} displayname - User nickname.
     * @param {string} formattedDisplayName - The display name shown in VietMeet
     * meet's UI for the user.
     * @returns {void}
     */
    notifyDisplayNameChanged(
    // @ts-ignore
    id, 
    // @ts-ignore
    { displayName, formattedDisplayName }) {
        this._sendEvent({
            name: 'display-name-change',
            displayname: displayName,
            formattedDisplayName,
            id
        });
    }
    /**
     * Notify external application (if API is enabled) that user changed their
     * email.
     *
     * @param {string} id - User id.
     * @param {string} email - The new email of the participant.
     * @returns {void}
     */
    notifyEmailChanged(
    // @ts-ignore
    id, 
    // @ts-ignore
    { email }) {
        this._sendEvent({
            name: 'email-change',
            email,
            id
        });
    }
    /**
     * Notify external application (if API is enabled) that the an error has been logged.
     *
     * @param {string} logLevel - The message log level.
     * @param {Array<string>} args - Array of strings composing the log message.
     * @returns {void}
     */
    // @ts-ignore
    notifyLog(logLevel, args = []) {
        if (!Array.isArray(args)) {
            logger.error('notifyLog received wrong argument types!');
            return;
        }
        // Trying to convert arguments to strings. Otherwise in order to send the event the arguments will be formatted
        // with JSON.stringify which can throw an error because of circular objects and we will lose the whole log.
        // @ts-ignore
        const formattedArguments = [];
        args.forEach(arg => {
            let formattedArgument = '';
            // @ts-ignore
            if (arg instanceof Error) {
                // @ts-ignore
                formattedArgument += `${arg.toString()}: ${arg.stack}`;
            }
            else if (typeof arg === 'object') {
                // NOTE: The non-enumerable properties of the objects wouldn't be included in the string after
                // JSON.stringify. For example Map instance will be translated to '{}'. So I think we have to eventually
                // do something better for parsing the arguments. But since this option for stringify is part of the
                // public interface and I think it could be useful in some cases I will it for now.
                try {
                    formattedArgument += JSON.stringify(arg);
                }
                catch (error) {
                    formattedArgument += arg;
                }
            }
            else {
                formattedArgument += arg;
            }
            formattedArguments.push(formattedArgument);
        });
        this._sendEvent({
            name: 'log',
            logLevel,
            // @ts-ignore
            args: formattedArguments
        });
    }
    /**
     * Notify external application (if API is enabled) that the conference has
     * been joined.
     *
     * @param {string} roomName - The room name.
     * @param {string} id - The id of the local user.
     * @param {Object} props - The display name, the avatar URL of the local
     * user and the type of the room.
     * @returns {void}
     */
    // @ts-ignore
    notifyConferenceJoined(roomName, id, props) {
        this._sendEvent({
            name: 'video-conference-joined',
            roomName,
            id,
            ...props
        });
    }
    /**
     * Notify external application (if API is enabled) that local user has left the conference.
     *
     * @param {string} roomName - User id.
     * @returns {void}
     */
    // @ts-ignore
    notifyConferenceLeft(roomName) {
        this._sendEvent({
            name: 'video-conference-left',
            roomName
        });
    }
    /**
     * Notify external application that the data channel has been closed.
     *
     * @param {number} code - The close code.
     * @param {string} reason - The close reason.
     *
     * @returns {void}
     */
    // @ts-ignore
    notifyDataChannelClosed(code, reason) {
        this._sendEvent({
            name: 'data-channel-closed',
            code,
            reason
        });
    }
    /**
     * Notify external application that the data channel has been opened.
     *
     * @returns {void}
     */
    notifyDataChannelOpened() {
        this._sendEvent({ name: 'data-channel-opened' });
    }
    /**
     * Notify external application (if API is enabled) that we are ready to be
     * closed.
     *
     * @returns {void}
     */
    notifyReadyToClose() {
        this._sendEvent({ name: 'video-ready-to-close' });
    }
    /**
     * Notify external application (if API is enabled) that a suspend event in host computer.
     *
     * @returns {void}
     */
    notifySuspendDetected() {
        this._sendEvent({ name: 'suspend-detected' });
    }
    /**
     * Notify external application (if API is enabled) for audio muted status
     * changed.
     *
     * @param {boolean} muted - The new muted status.
     * @returns {void}
     */
    // @ts-ignore
    notifyAudioMutedStatusChanged(muted) {
        this._sendEvent({
            name: 'audio-mute-status-changed',
            muted
        });
    }
    /**
     * Notify external application (if API is enabled) for video muted status
     * changed.
     *
     * @param {boolean} muted - The new muted status.
     * @returns {void}
     */
    // @ts-ignore
    notifyVideoMutedStatusChanged(muted) {
        this._sendEvent({
            name: 'video-mute-status-changed',
            muted
        });
    }
    /**
     * Notify external application (if API is enabled) for audio availability
     * changed.
     *
     * @param {boolean} available - True if available and false otherwise.
     * @returns {void}
     */
    // @ts-ignore
    notifyAudioAvailabilityChanged(available) {
        audioAvailable = available;
        this._sendEvent({
            name: 'audio-availability-changed',
            available
        });
    }
    /**
     * Notify external application (if API is enabled) for video available
     * status changed.
     *
     * @param {boolean} available - True if available and false otherwise.
     * @returns {void}
     */
    // @ts-ignore
    notifyVideoAvailabilityChanged(available) {
        videoAvailable = available;
        this._sendEvent({
            name: 'video-availability-changed',
            available
        });
    }
    /**
     * Notify external application (if API is enabled) that the on stage
     * participant has changed.
     *
     * @param {string} id - User id of the new on stage participant.
     * @returns {void}
     */
    // @ts-ignore
    notifyOnStageParticipantChanged(id) {
        this._sendEvent({
            name: 'on-stage-participant-changed',
            id
        });
    }
    /**
     * Notify external application (if API is enabled) that the prejoin video
     * visibility had changed.
     *
     * @param {boolean} isVisible - Whether the prejoin video is visible.
     * @returns {void}
     */
    // @ts-ignore
    notifyPrejoinVideoVisibilityChanged(isVisible) {
        this._sendEvent({
            name: 'on-prejoin-video-changed',
            isVisible
        });
    }
    /**
     * Notify external application (if API is enabled) that the prejoin
     * screen was loaded.
     *
     * @returns {void}
     */
    notifyPrejoinLoaded() {
        const state = APP.store.getState();
        const { defaultLocalDisplayName } = state['features/base/config'];
        const displayName = getDisplayName(state);
        this._sendEvent({
            name: 'prejoin-screen-loaded',
            id: LOCAL_PARTICIPANT_DEFAULT_ID,
            displayName,
            formattedDisplayName: appendSuffix(displayName, defaultLocalDisplayName)
        });
    }
    /**
     * Notify external application of an unexpected camera-related error having
     * occurred.
     *
     * @param {string} type - The type of the camera error.
     * @param {string} message - Additional information about the error.
     * @returns {void}
     */
    // @ts-ignore
    notifyOnCameraError(type, message) {
        this._sendEvent({
            name: 'camera-error',
            type,
            message
        });
    }
    /**
     * Notify external application of an unexpected mic-related error having
     * occurred.
     *
     * @param {string} type - The type of the mic error.
     * @param {string} message - Additional information about the error.
     * @returns {void}
     */
    // @ts-ignore
    notifyOnMicError(type, message) {
        this._sendEvent({
            name: 'mic-error',
            type,
            message
        });
    }
    /**
     * Notify external application (if API is enabled) that conference feedback
     * has been submitted. Intended to be used in conjunction with the
     * submit-feedback command to get notified if feedback was submitted.
     *
     * @param {string} error - A failure message, if any.
     * @returns {void}
     */
    // @ts-ignore
    notifyFeedbackSubmitted(error) {
        this._sendEvent({
            name: 'feedback-submitted',
            error
        });
    }
    /**
     * Notify external application (if API is enabled) that the feedback prompt
     * has been displayed.
     *
     * @returns {void}
     */
    notifyFeedbackPromptDisplayed() {
        this._sendEvent({ name: 'feedback-prompt-displayed' });
    }
    /**
     * Notify external application (if API is enabled) that the display
     * configuration of the filmstrip has been changed.
     *
     * @param {boolean} visible - Whether or not the filmstrip has been set to
     * be displayed or hidden.
     * @returns {void}
     */
    // @ts-ignore
    notifyFilmstripDisplayChanged(visible) {
        this._sendEvent({
            name: 'filmstrip-display-changed',
            visible
        });
    }
    /**
     * Notify external application of a participant, remote or local, being
     * removed from the conference by another participant.
     *
     * @param {Object} kicked - The participant removed from the
     * conference.
     * @param {Object} kicker - The participant that removed the
     * other participant.
     * @returns {void}
     */
    // @ts-ignore
    notifyKickedOut(kicked, kicker) {
        this._sendEvent({
            name: 'participant-kicked-out',
            kicked,
            kicker
        });
    }
    /**
     * Notify external application (if API is enabled) that the recording consent dialog open state has changed.
     *
     * @param {boolean} open - True if the dialog is open, false otherwise.
     * @returns {void}
     */
    // @ts-ignore
    notifyRecordingConsentDialogOpen(open) {
        this._sendEvent({
            name: 'recording-consent-dialog-open',
            open
        });
    }
    /**
     * Notify external application that the voice-agent consent dialog was opened or closed.
     *
     * @param {boolean} open - Whether the dialog is open.
     * @param {string} id - The agent the dialog is about.
     * @returns {void}
     */
    // @ts-ignore
    notifyVoiceAgentConsentDialogOpen(open, id) {
        this._sendEvent({
            name: 'voice-agent-consent-dialog-open',
            id,
            open
        });
    }
    /**
     * Notify external application of the current meeting requiring a password
     * to join.
     *
     * @returns {void}
     */
    notifyOnPasswordRequired() {
        this._sendEvent({ name: 'password-required' });
    }
    /**
     * Notify external application (if API is enabled) that the screen sharing
     * has been turned on/off.
     *
     * @param {boolean} on - True if screen sharing is enabled.
     * @param {Object} details - Additional information about the screen
     * sharing.
     * @param {string} details.sourceType - Type of device or window the screen
     * share is capturing.
     * @returns {void}
     */
    // @ts-ignore
    notifyScreenSharingStatusChanged(on, details) {
        this._sendEvent({
            name: 'screen-sharing-status-changed',
            on,
            details
        });
    }
    /**
     * Notify external application (if API is enabled) that the dominant speaker
     * has been turned on/off.
     *
     * @param {string} id - Id of the dominant participant.
     * @returns {void}
     */
    // @ts-ignore
    notifyDominantSpeakerChanged(id) {
        this._sendEvent({
            name: 'dominant-speaker-changed',
            id
        });
    }
    /**
     * Notify external application (if API is enabled) that the conference
     * changed their subject.
     *
     * @param {string} subject - Conference subject.
     * @returns {void}
     */
    // @ts-ignore
    notifySubjectChanged(subject) {
        this._sendEvent({
            name: 'subject-change',
            subject
        });
    }
    /**
     * Notify external application (if API is enabled) that tile view has been
     * entered or exited.
     *
     * @param {string} enabled - True if tile view is currently displayed, false
     * otherwise.
     * @returns {void}
     */
    // @ts-ignore
    notifyTileViewChanged(enabled) {
        this._sendEvent({
            name: 'tile-view-changed',
            enabled
        });
    }
    /**
     * Notify external application (if API is enabled) that the localStorage has changed.
     *
     * @param {string} localStorageContent - The new localStorageContent.
     * @returns {void}
     */
    // @ts-ignore
    notifyLocalStorageChanged(localStorageContent) {
        this._sendEvent({
            name: 'local-storage-changed',
            localStorageContent
        });
    }
    /**
     * Notify external application (if API is enabled) that user updated their hand raised.
     *
     * @param {string} id - User id.
     * @param {boolean} handRaised - Whether user has raised hand.
     * @returns {void}
     */
    // @ts-ignore
    notifyRaiseHandUpdated(id, handRaised) {
        this._sendEvent({
            name: 'raise-hand-updated',
            handRaised,
            id
        });
    }
    /**
     * Notify external application (if API is enabled) that recording has started or stopped.
     *
     * @param {boolean} on - True if recording is on, false otherwise.
     * @param {string} mode - Stream or file or local.
     * @param {string} error - Error type or null if success.
     * @param {boolean} transcription - True if a transcription is being recorded, false otherwise.
     * @returns {void}
     */
    // @ts-ignore
    notifyRecordingStatusChanged(on, mode, error, transcription) {
        this._sendEvent({
            name: 'recording-status-changed',
            on,
            mode,
            error,
            transcription
        });
    }
    /**
     * Notify external application (if API is enabled) that the current recording link is
     * available.
     *
     * @param {string} link - The recording download link.
     * @param {number} ttl - The recording download link time to live.
     * @returns {void}
     */
    // @ts-ignore
    notifyRecordingLinkAvailable(link, ttl) {
        this._sendEvent({
            name: 'recording-link-available',
            link,
            ttl
        });
    }
    /**
     * Notify external application (if API is enabled) that a participant is knocking in the lobby.
     *
     * @param {Object} participant - Participant data such as id and name.
     * @returns {void}
     */
    // @ts-ignore
    notifyKnockingParticipant(participant) {
        this._sendEvent({
            name: 'knocking-participant',
            participant
        });
    }
    /**
     * Notify external application (if API is enabled) that an error occurred.
     *
     * @param {Object} error - The error.
     * @returns {void}
     */
    // @ts-ignore
    notifyError(error) {
        this._sendEvent({
            name: 'error-occurred',
            error
        });
    }
    /**
     * Notify external application ( if API is enabled) that a toolbar button was clicked.
     *
     * @param {string} key - The key of the toolbar button.
     * @param {boolean} preventExecution - Whether execution of the button click was prevented or not.
     * @returns {void}
     */
    // @ts-ignore
    notifyToolbarButtonClicked(key, preventExecution) {
        this._sendEvent({
            name: 'toolbar-button-clicked',
            key,
            preventExecution
        });
    }
    /**
     * Notify external application (if API is enabled) that transcribing has started or stopped.
     *
     * @param {boolean} on - True if transcribing is on, false otherwise.
     * @returns {void}
     */
    // @ts-ignore
    notifyTranscribingStatusChanged(on) {
        this._sendEvent({
            name: 'transcribing-status-changed',
            on
        });
    }
    /**
     * Notify external application (if API is enabled) that the user received
     * a transcription chunk.
     *
     * @param {Object} data - The event data.
     * @returns {void}
     */
    // @ts-ignore
    notifyTranscriptionChunkReceived(data) {
        this._sendEvent({
            name: 'transcription-chunk-received',
            data
        });
    }
    /**
     * Notify external application (if API is enabled) whether the used browser is supported or not.
     *
     * @param {boolean} supported - If browser is supported or not.
     * @returns {void}
     */
    // @ts-ignore
    notifyBrowserSupport(supported) {
        this._sendEvent({
            name: 'browser-support',
            supported
        });
    }
    /**
     * Notify external application that the breakout rooms changed.
     *
     * @param {Array} rooms - Array containing the breakout rooms and main room.
     * @returns {void}
     */
    // @ts-ignore
    notifyBreakoutRoomsUpdated(rooms) {
        this._sendEvent({
            name: 'breakout-rooms-updated',
            rooms
        });
    }
    /**
     * Notify the external application that the state of the participants pane changed.
     *
     * @param {boolean} open - Whether the panel is open or not.
     * @returns {void}
     */
    // @ts-ignore
    notifyParticipantsPaneToggled(open) {
        this._sendEvent({
            name: 'participants-pane-toggled',
            open
        });
    }
    /**
     * Notify the external application that a file has been uploaded.
     *
     * @param {Object} fileMetadata - The file metadata.
     * @returns {void}
     */
    // @ts-ignore
    notifyFileUploaded(fileMetadata) {
        this._sendEvent({
            name: 'file-uploaded',
            file: fileMetadata
        });
    }
    /**
     * Notify the external application that a file has been deleted.
     *
     * @param {string} fileId - The ID of the deleted file.
     * @returns {void}
     */
    // @ts-ignore
    notifyFileDeleted(fileId) {
        this._sendEvent({
            name: 'file-deleted',
            fileId
        });
    }
    /**
     * Notify the external application that the audio or video is being shared by a participant.
     *
     * @param {string} mediaType - Whether the content which is being shared is audio or video.
     * @param {string} value - Whether the sharing is playing, pause or stop (on audio there is only playing and stop).
     * @param {string} participantId - Participant id of the participant which started or ended
     *  the video or audio sharing.
     * @returns {void}
     */
    // @ts-ignore
    notifyAudioOrVideoSharingToggled(mediaType, value, participantId) {
        this._sendEvent({
            name: 'audio-or-video-sharing-toggled',
            mediaType,
            value,
            participantId
        });
    }
    /**
     * Notify the external application that a PeerConnection lost connectivity. This event is fired only if
     * a PC `failed` but connectivity to the rtcstats server is still maintained signaling that there is a
     * problem establishing a link between the app and the JVB server or the remote peer in case of P2P.
     * Will only fire if rtcstats is enabled.
     *
     * @param {boolean} isP2P - Type of PC.
     * @param {boolean} wasConnected - Was this connection previously connected. If it was it could mean
     * that connectivity was disrupted, if not it most likely means that the app could not reach
     * the JVB server, or the other peer in case of P2P.
     *
     * @returns {void}
     */
    // @ts-ignore
    notifyPeerConnectionFailure(isP2P, wasConnected) {
        this._sendEvent({
            name: 'peer-connection-failure',
            isP2P,
            wasConnected
        });
    }
    /**
     * Requests that the embedding page close Document PiP.
     *
     * @returns {void}
     */
    notifyDocumentPiPClose() {
        this._sendEvent({ name: '_document-pip-close' });
    }
    /**
     * Requests a host-owned Document PiP window.
     *
     * @returns {void}
     */
    notifyDocumentPiPRequested() {
        this._sendEvent({ name: '_document-pip-requested' });
    }
    /**
     * Sends one ordered WebRTC signal to the embedding page.
     *
     * @param {Object} signal - Offer, answer, candidate, mute, restart, or stop signal.
     * @returns {void}
     */
    // @ts-ignore
    notifyDocumentPiPSignal(signal) {
        this._sendEvent({
            name: '_document-pip-signal',
            signal
        });
    }
    /**
     * Notify external application (if API is enabled) that Picture-in-Picture was requested.
     * Used by Electron to handle PiP requests with proper user gesture context.
     *
     * @returns {void}
     */
    notifyPictureInPictureRequested() {
        logger.debug('Sending _pip-requested event to External API');
        this._sendEvent({
            name: '_pip-requested'
        });
    }
    /**
     * Notify external application (if API is enabled) that Picture-in-Picture mode was entered.
     *
     * @returns {void}
     */
    notifyPictureInPictureEntered() {
        logger.debug('Sending pip-entered event to External API');
        this._sendEvent({
            name: 'pip-entered'
        });
    }
    /**
     * Notify external application (if API is enabled) that Picture-in-Picture mode was exited.
     *
     * @returns {void}
     */
    notifyPictureInPictureLeft() {
        logger.debug('Sending pip-left event to External API');
        this._sendEvent({
            name: 'pip-left'
        });
    }
    /**
     * Notify external application (if API is enabled) that a second-screen window now renders a
     * given source/participant.
     *
     * @param {Object} data - The event payload ({ id, source, participantId }).
     * @returns {void}
     */
    // @ts-ignore
    notifySecondScreenSourceChanged(data) {
        this._sendEvent({
            name: 'second-screen-source-changed',
            ...data
        });
    }
    /**
     * Notify external application (if API is enabled) that a second-screen window was closed.
     *
     * @param {Object} data - The event payload ({ id }).
     * @returns {void}
     */
    // @ts-ignore
    notifySecondScreenClosed(data) {
        this._sendEvent({
            name: 'second-screen-closed',
            ...data
        });
    }
    /**
     * Notify external application (if API is enabled) that a second-screen window could not be
     * opened/updated (e.g. popup blocked or the feature disabled).
     *
     * @param {Object} data - The event payload ({ id, error }).
     * @returns {void}
     */
    // @ts-ignore
    notifySecondScreenError(data) {
        this._sendEvent({
            name: 'second-screen-error',
            ...data
        });
    }
    /**
     * Notify external application ( if API is enabled) that a participant menu button was clicked.
     *
     * @param {string} key - The key of the participant menu button.
     * @param {string} participantId - The ID of the participant for whom the participant menu button was clicked.
     * @param {boolean} preventExecution - Whether execution of the button click was prevented or not.
     * @returns {void}
     */
    // @ts-ignore
    notifyParticipantMenuButtonClicked(key, participantId, preventExecution) {
        this._sendEvent({
            name: 'participant-menu-button-clicked',
            key,
            participantId,
            preventExecution
        });
    }
    /**
     * Notify external application (if API is enabled) if whiteboard state is
     * changed.
     *
     * @param {WhiteboardStatus} status - The new whiteboard status.
     * @returns {void}
     */
    // @ts-ignore
    notifyWhiteboardStatusChanged(status) {
        this._sendEvent({
            name: 'whiteboard-status-changed',
            status
        });
    }
    /**
     * Notify external application (if API is enabled) if non participant message
     * is received.
     *
     * @param {string} id - The resource id of the sender.
     * @param {Object} json - The json carried by the message.
     * @returns {void}
     */
    // @ts-ignore
    notifyNonParticipantMessageReceived(id, json) {
        this._sendEvent({
            name: 'non-participant-message-received',
            id,
            message: json
        });
    }
    /**
     * Notify external application (if API is enabled) the conference
     * start time.
     *
     * @param {number} timestamp - Timestamp conference was created.
     * @returns {void}
     */
    // @ts-ignore
    notifyConferenceCreatedTimestamp(timestamp) {
        this._sendEvent({
            name: 'conference-created-timestamp',
            timestamp
        });
    }
    /**
     * Notify the external application (if API is enabled) if the connection type changed.
     *
     * @param {boolean} isP2p - Whether the new connection is P2P.
     * @returns {void}
     */
    // @ts-ignore
    notifyP2pStatusChanged(isP2p) {
        this._sendEvent({
            name: 'p2p-status-changed',
            isP2p
        });
    }
    /**
     * Notify the external application (if API is enabled) when the compute pressure changed.
     *
     * @param {Array} records - The new pressure records.
     * @returns {void}
     */
    // @ts-ignore
    notifyComputePressureChanged(records) {
        this._sendEvent({
            name: 'compute-pressure-changed',
            records
        });
    }
    /**
     * Notify the external application (if API is enabled) when the audio only enabled status changed.
     *
     * @param {boolean} enabled - Whether the audio only is enabled or not.
     * @returns {void}
     */
    // @ts-ignore
    notifyLowBandwidthModeChanged(enabled) {
        this._sendEvent({
            name: 'low-bandwidth-mode-changed',
            enabled
        });
    }
    /**
     * Disposes the allocated resources.
     *
     * @returns {void}
     */
    dispose() {
        if (this._enabled) {
            this._enabled = false;
        }
    }
}
export default new API();
